import colors from "@/constants/colors"
import gradients from "@/constants/gradients"

const getBackground = (backgroundColor:string, pseudo?:string) => {
    switch (backgroundColor) {
        case colors.lightGray:
        return 'bg-secondary-50'
        case colors.transparent:
        return 'bg-transparent'
        case colors.deepBlue:
        return !pseudo ? 'bg-midnight-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-midnight-gradient text-secondary-50'
        case colors.simpleNavPrimaryBlue:
        return 'bg-simpleNavPrimaryBlue text-secondary-50'
        case colors.simpleNavWhite:
        return  'bg-simpleNavWhite text-secondary-900'
        case colors.primaryBlue:
        return !pseudo ? 'bg-midnight-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-midnight-gradient text-secondary-50'
        case colors.indigoBlue:
        return !pseudo ? 'bg-midnight-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-midnight-gradient text-secondary-50'
        case colors.white:
        return !pseudo ? 'bg-midnight-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-midnight-gradient text-secondary-50'
        case gradients.midnight:
        return !pseudo ? 'bg-midnight-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-midnight-gradient text-secondary-50'
        case gradients.dusk:
        return !pseudo ? 'bg-dusk-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-dusk-gradient text-secondary-50'
        case gradients.atmostphere:
        return !pseudo ? 'bg-atmosphere-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-atmosphere-gradient text-secondary-50'
        case gradients.space:
        return !pseudo ? 'bg-space-gradient text-secondary-50' : pseudo === 'after' && 'after:bg-space-gradient text-secondary-50'
        case gradients.horizon:
        return !pseudo ? 'bg-horizon-gradient' : pseudo === 'after' && 'after:bg-horizon-gradient'
        case gradients.sea:
        return !pseudo ? 'bg-sea-gradient' : pseudo === 'after' && 'after:bg-sea-gradient'
        case gradients.arctic:
        return !pseudo ? 'bg-arctic-gradient' : pseudo === 'after' && 'after:bg-arctic-gradient'
        default:
        return null
    }
}

export default getBackground